// Visit report submission form — route /sr/:id/report
// Q9 S3 — replaced monolithic <form> with <VisitReportWizard>. The wizard
// PATCHes per section on step nav (D10) and submits via POST /submit (D19).
// PatientHeader replaces the SR-hash chrome (PAIN-CATALOG line 172).

import { useParams, useNavigate } from "react-router-dom";
import type { JSX } from "react";
import { Shell } from "../components/Shell.js";
import { PatientHeader } from "../components/PatientHeader.js";
import { VisitReportWizard } from "../components/VisitReportWizard.js";
import { useVisitReportData } from "../hooks/useVisitReportData.js";

// Re-export for backward compatibility — apps/web/src/features/reports/__tests__/
// MedicationSection.test.tsx imports buildPayload through this path historically.
// The actual implementation lives at lib/visit-report-payload.ts (Q9 S3).
export { buildPayload } from "../lib/visit-report-payload.js";

export function VisitReportPage(): JSX.Element {
  const { id = "" } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { ready, srData, patientData, isAtWanderingRisk } = useVisitReportData(id);

  if (!ready || !srData || !patientData) {
    return <Shell><p className="p-8 text-sm text-slate-400" aria-busy="true">Loading…</p></Shell>;
  }

  return (
    <Shell>
      <div className="max-w-5xl mx-auto px-4 py-6">
        <button onClick={() => navigate(`/sr/${id}`)} className="text-sm text-navy-700 hover:underline mb-4">← Back</button>
        <PatientHeader patient={patientData} sr={srData} />
        <VisitReportWizard
          srId={id}
          patientId={srData.patient_id}
          baselineMobility={patientData.baseline_mobility ?? null}
          initialVisitType={srData.visit_type ?? null}
          isAtWanderingRisk={isAtWanderingRisk}
          submissionChannel="crm"
          onSubmitted={() => { navigate(`/sr/${id}`); }}
        />
      </div>
    </Shell>
  );
}
